var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("年夜饭预定管理")]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "reunionPreOrderManagement" } } },
              [_vm._v("年夜饭预定订单管理")]
            ),
            _c("el-breadcrumb-item", [_vm._v("详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "detail-container box-shadow" }, [
      _c("div", { staticClass: "detail-content" }, [
        _c("div", { staticClass: "row space-between" }, [
          _c(
            "div",
            { staticClass: "row-no-padding left" },
            [
              _c("span", { staticClass: "title" }, [_vm._v("预定餐厅：")]),
              _c("span", { staticClass: "content" }, [
                _vm._v(_vm._s(_vm.orderDetail.canteenName)),
              ]),
              _c("el-image", {
                staticClass: "image",
                attrs: {
                  src: _vm.orderDetail.canteenPicture,
                  "preview-src-list": [_vm.orderDetail.canteenPicture],
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.orderDetail.orderStatus === 1,
                  expression: "orderDetail.orderStatus === 1",
                },
              ],
              staticClass: "right",
            },
            [_vm._v("待完成")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.orderDetail.orderStatus === 2,
                  expression: "orderDetail.orderStatus === 2",
                },
              ],
              staticClass: "right",
            },
            [_vm._v("已完成")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.orderDetail.orderStatus === 3,
                  expression: "orderDetail.orderStatus === 3",
                },
              ],
              staticClass: "right",
            },
            [_vm._v("已取消")]
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("span", { staticClass: "title" }, [_vm._v("餐厅电话：")]),
          _c("span", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.orderDetail.canteenMobile)),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("span", { staticClass: "title" }, [_vm._v("餐厅地址：")]),
          _c("span", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.orderDetail.canteenAddress)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.roomList } },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "房间主图",
                    align: "center",
                    prop: "roomPicture",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-image", {
                            staticStyle: {
                              "max-width": "120px",
                              "max-height": "120px",
                              "border-radius": "6px",
                            },
                            attrs: {
                              src: scope.row.roomPicture,
                              "preview-src-list": [scope.row.roowmPicture],
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "房间名称",
                    align: "center",
                    prop: "roomName",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "房间容量",
                    align: "center",
                    prop: "capacity",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "预定时间",
                    align: "center",
                    prop: "presetTime",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(scope.row.presetTime)
                                )
                              ),
                            ]
                          ),
                          scope.row.type === 1
                            ? _c("span", [_vm._v("上午")])
                            : _vm._e(),
                          scope.row.type === 2
                            ? _c("span", [_vm._v("下午")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "预定电话", align: "center", prop: "mobile" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "detail-footer" }, [
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _c("span", { staticClass: "title" }, [_vm._v("订单号码：")]),
          _c("span", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.orderDetail.orderNo)),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("span", { staticClass: "title" }, [_vm._v("下单时间：")]),
          _c("span", { staticClass: "content" }, [
            _vm._v(
              _vm._s(_vm._f("formatDate")(_vm.orderDetail.createdDate, true))
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("span", { staticClass: "main-title" }, [_vm._v("订单信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }